module.exports = __webpack_public_path__ + "img/sleeve_length.6b9c5a59.png";